export const LTS_PAGES = [
  'analyzing-activity',
  'analyzing-body',
  'analyzing',
  'analyzing-2',
  'analyzing-3',
  'analyzing-4',
  'best-app',
  'email-2',
  'preland',
  'lts-photo-example',
  'face-scan',
  'face-scan-animation',
  'face-scan-id',
  'lts-result',
  'analyzing-answers',
  'upsale-without-trial',
  'take-pictures',
  'almost-done',
  'web-upsale-1',
  'web-upsale-3',
  'web-upsale-4',
  'web-upsale-5',
  'personal-plan',
  'personal-plan-2',
  'personal-plan-3',
  'personal-plan-4',
  'personal-plan-metabolism',
  'personal-plan-dynamic',
  'paywall',
  'upsale-nutrition-bundle',
  'upsale-dynamic',
  'full-body-photo',

  // deferred-email step of the hairstyle flow — it paints the hairstyle palette
  // itself, so it takes the thin layout, not MainLayout's green one.
  // (hairstyle-* pages aren't listed here: layout-generator routes them to
  // HairstyleLayout / HairstyleWomenLayout by prefix.)
  'email-after-payment',
];
